import {
  create_customer_base_info,
  check_customer_wallet_info,
  update_customer_base_info,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model2/mjstore/mjstore-tips-config';

import { reactive } from 'vue';

const None = null;

const search_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '撤单管理',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '日期',
    dataIndex: 'datetime',
    width: 150,
    checked: true,
    slots: { customRender: 'date' },
  },
  {
    title: '项目',
    width: 150,
    dataIndex: 'event_name',
    checked: true,
  },
  {
    title: '充值金额',
    width: 150,
    dataIndex: 'cz_price',
    checked: true,
    slots: { customRender: 'content' },
  },
  {
    title: '返利金额',
    width: 150,
    dataIndex: 'fl_price',
    checked: true,
    slots: { customRender: 'content' },
  },
  {
    title: '总金额',
    width: 150,
    dataIndex: 'total_price',
    checked: true,
    slots: { customRender: 'content' },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'content',
  slotName: 'content',
  content: (record: any, text: any) => {
    let str: any = '';
    if (text > 0) {
      str = '+' + text;
    } else {
      str = text;
    }
    return str;
  },
  color: (record: any, text: any) => {
    let color: any = '';
    if (text < 0) {
      color = 'color: red';
    } else {
      color = 'color: green';
    }
    return color;
  },
});
export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: check_customer_wallet_info,
    addData: create_customer_base_info,
    updateData: update_customer_base_info,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
